module.exports = __webpack_public_path__ + "img/screen-participants-es.55df1377.png";